import { createContext, useContext } from "react";
export const BlockEngineApiContext = createContext(null);
function apiHook(name) {
    return ((...args) => {
        const blockEngineApi = useContext(BlockEngineApiContext);
        if (blockEngineApi === null) {
            throw new Error("Using a restricted hook outside of BlockEngineApi Context");
        }
        return blockEngineApi[name].apply(blockEngineApi, args);
    });
}
export const useEditor = apiHook("useEditor");
export const useInspectorControl = apiHook("useInspectorControl");
export const useToolbar = apiHook("useToolbar");
export const useSmartProp = apiHook("useSmartProp");
export const useChildrenBlocks = apiHook("useChildrenBlocks");
export const useBlockContext = apiHook("useBlockContext");
export const useBlock = apiHook("useBlock");

//# sourceMappingURL=BlockEngineApi.js.map
